import { render, staticRenderFns } from "./MessagePpeRegister.vue?vue&type=template&id=00868a23&"
import script from "./MessagePpeRegister.vue?vue&type=script&lang=js&"
export * from "./MessagePpeRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports